module.exports = __webpack_public_path__ + "static/media/quindio-27.1e2bdd51.jpg";